import React from 'react'
import ReactDOM from 'react-dom'

import './i18n.js'

import App from './components/App'

ReactDOM.render(<App />, document.getElementById('root'))